import React from "react"
import DataTable from "../../DataTable/DataTable"

class ProductPresenterNotes extends React.Component {

  constructor(props) {
    super(props);
  };

  render() {
    return(
      <div className="notes">
        <DataTable endpoint={this.props.product_notes_path} updateNoteCount={this.updateNoteCount} date_format={this.props.date_format} time_format={this.props.time_format} read_only={true} />
      </div>
    );
  };

};

export default ProductPresenterNotes